export default __webpack_public_path__ + "static/media/slide3.fc7c04a4.jpg";